import AppUser from '@/components/App/AppUser.vue'

const User = {
  install(Vue) {
    this.EventBus = new Vue()
    Vue.component('app-user', AppUser)
    Vue.prototype.$user = {
      add(params) {
        User.EventBus.$emit('add', params)
      },
      edit(params) {
        User.EventBus.$emit('edit', params)
      }
    }
  }
}

export default User